module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAiCAMAAACZf1ICAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRFy9rS2dra0ebc6+vr2uzkydPN/Pz88vTz6fPt4eLj1unhzuDY9vj20dHR////3u7pnciB5AAAAONJREFUeNp8k0uWxSAIRFH8K7r/3TaY5CUk2jVw4JUCPSX0ldJc4bMfh7MuflmS/SFSrKVR7LhUfkyOl/GUnay5x/EXS2OpNOvKGs5+donKf6ztmZhC3/RjU8C6ZvxsgLDxdMy8WzObAGldWEKDSKtCVzPPEok+t6jekznYa1LrScRzBlINXT0IUea7E/kbwUVYDXomKtrtlIF+mpYKihAiZyLLpFUDRjMvPCk4jTKGI0ts6kE1Cv2XXaNr4hVLYfnZJtxJFoYft5udpiaj/hmT4cvsybq8Xt8wQ2HL2gr1PwEGAD1+LqYv07dhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/CT.png
// module id = pTkI
// module chunks = 1